import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Paper, RaisedButton } from "material-ui";
import styles from "../../styles/styles";
import urlHelper from "../../../helpers/urlHelper";

class DetalleSolicitudSE extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  componentWillMount() { }

  ModalSolicitudReajuste = () => {
    urlHelper.RedirectTo("SolicitudesRealizadas");
  }

  render() {
    return (


      <Paper zDepth={1} rounded={false} width="100%" style={{ margin: "10px 0px", width: "100%", padding: "10px 5px" }} >
        <div className="col-12" style={{ margin: 0, padding: 0 }}>
          <div style={styles.h1}>
            Solicitud Especial
            {this.props.detalleSolicitud.EsReplicacion ? ` replicada en isapre ${this.props.isapre === "B" ? "Vida Tres" : "Banmédica"}` : null}
          </div>
        </div>
        {this.props.detalleSolicitud.IdSolicitud > 0 ?
          <div className="col-12" style={{ margin: "10px 0px", padding: 0 }}>
            <div className="row">
              <div className="col-3" style={styles.tituloEnviarSolicitud}>
                <strong>N°  solicitud: </strong>
              </div>
              <div className="col-3" style={styles.datoEnviarSolicitud}>
                {this.props.detalleSolicitud.IdSolicitud}
              </div>
              <div className="col-3" style={styles.tituloEnviarSolicitud}>
                <strong>Fecha Solicitud: </strong>
              </div>
              <div className="col-3" style={styles.datoEnviarSolicitud}>
                {this.props.detalleSolicitud.FechaCreacion}
              </div>
            </div>
            <div className="row">
              <div className="col-3" style={styles.tituloEnviarSolicitud}>
                <strong>N°  solicitud Homologador: </strong>
              </div>
              <div className="col-3" style={styles.datoEnviarSolicitud}>
                {(this.props.detalleSolicitud.IdSolicitudHomologa === 0) ? 'No Aplica' : this.props.detalleSolicitud.IdSolicitudHomologa}
              </div>
            </div>
            <div className="row">
              <div className="col-3" style={styles.tituloEnviarSolicitud}>
                <strong>Tipo Solicitud: </strong>
              </div>
              <div className="col-3" style={styles.datoEnviarSolicitud}>
                Solicitud Especial
              </div>
              <div className="col-3" style={styles.tituloEnviarSolicitud}>
                <strong>Estado Solicitud: </strong>
              </div>
              <div className="col-3" style={styles.datoEnviarSolicitud}>
                {this.props.detalleSolicitud.EstadoSE}
              </div>
            </div>

            {this.props.detalleSolicitud.IdEstadoSE === 53 ?
              <div className="row">
                <div className="col-12" style={{ marginTop: "10px" }}>
                  <div style={styles.h3}>
                    La resolución de su solicitud será notificada vía electrónica a su email
                    de contacto. De igual forma podrá revisar lo solicitado y el estado de
                    su solicitud en el menú
                    <RaisedButton
                      label="Solicitudes Realizadas"
                      onClick={this.ModalSolicitudReajuste}
                      secondary
                      labelStyle={{ fontSize: "11px" }}
                      overlayStyle={{ borderRadius: 5 }}
                      rippleStyle={{ borderRadius: 5 }}
                      style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
                      buttonStyle={{ borderRadius: 5 }}
                    />
                  </div>
                </div>
              </div>
              : null}
          </div>
          : <div className="col-12" style={{ margin: "10px 0px", padding: 0 }}>
            <div className="row">
              <div className="col-12" style={styles.tituloEnviarSolicitud}>
                <strong>Ninguna de las prestaciones a Eliminar existe en Isapre {this.props.isapre === "B" ? "Vida Tres" : "Banmédica"} por lo tanto no se puede replicar.</strong>
              </div>
            </div>
          </div>
        }
      </Paper>


    );
  }
}

DetalleSolicitudSE.defaultProps = {
};

DetalleSolicitudSE.propTypes = {
  // dispatch: PropTypes.func.isRequired,
  detalleSolicitud: PropTypes.any.isRequired,
  isapre: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  isapre: state.global.isapre,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(DetalleSolicitudSE);
